(function () {
    function updateHeaderCart() {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const countEl = document.getElementById('cart-count');
          if (!countEl) return;

          if (cart.item_count > 0) {
            countEl.textContent = cart.item_count;
          } else {
            countEl.textContent = '';
          }
        });
    }
    function formatJPY(amount) {
      return new Intl.NumberFormat('ja-JP', {
        style: 'currency',
        currency: 'JPY',
        currencyDisplay: 'symbol'
      }).format(amount) + ' JPY';
    }
    document.addEventListener('DOMContentLoaded', function () {
        // for testing remove it if release
        updateHeaderCart()

        let atcPopupLock = false;
      
        function showATCPopup(item) {
          const popup = document.getElementById('atc-popup');
          if (!popup) return;
          
          document.getElementById('atc-popup-title').textContent = item.title;
          document.getElementById('atc-popup-image').src = item.image;
          document.getElementById('atc-popup-variant').textContent =
            formatJPY(item.presentment_price) || '';
      
          popup.style.display = 'block';
        }
      
        document.querySelector('.atc-popup__overlay').onclick = function () {
          document.getElementById('atc-popup').style.display = 'none';
        };
      
        $(document).ajaxComplete(function (event, xhr, settings) {
          if (!settings || !settings.url) return;
      
          // Match add-to-cart request
          if (!settings.url.includes('/cart/add.js')) return;
          // fetch after successfully update
          updateHeaderCart();
      
          let item;
          try {
            item = JSON.parse(xhr.responseText);
          } catch (e) {
            return;
          }
      
          if (!item || !item.title) return;
          if (atcPopupLock) return;
      
          atcPopupLock = true;
          showATCPopup(item);
      
          setTimeout(function () {
            atcPopupLock = false;
          }, 800);
        });
    });
})();
